<template>
  <home-project-card :project="project" badge="Finalizada" />
</template>

<script>
import HomeProjectCard from "./HomeProjectCard.vue";

export default {
  name: "HomeCompletedProjectCard",
  components: { HomeProjectCard },
  props: {
    project: { type: Object, required: true },
  },
};
</script>
